import {
  LOADING_LOANS,
  SET_SALARY_ADVANCE_LOANS,
  SET_GROUP_LOANS,
  SET_LOAN_ERROR,
} from './loans.type';
import initialState from '../initialState';

const loanState = {
  ...initialState,
  loadingLoans: true,
  groupLoans: null,
  salaryAdvanceLoans: null,
  loanError: null,
};

const loansReducer = (state = loanState, action) => {
  switch (action.type) {
    case LOADING_LOANS:
      return {
        ...state,
        loadingLoans: action.value,
      };

    case SET_SALARY_ADVANCE_LOANS:
      return {
        ...state,
        salaryAdvanceLoans: action.loans,
      };

    case SET_GROUP_LOANS:
      return {
        ...state,
        groupLoans: action.loans,
      };

    case SET_LOAN_ERROR:
      return {
        ...state,
        loandError: action.error,
      };

    default:
      return state;
  }
};

export default loansReducer;
